module.exports = __webpack_public_path__ + "img/government-right-3.55776540.png";